/**
 * Composant EmptyState
 * Affichage des états vides avec icône, titre, description et action optionnelle
 * Utilisé quand une liste est vide ou qu'aucune donnée n'est disponible
 */
import { ReactNode } from 'react'

interface EmptyStateAction {
  label: string
  onClick: () => void
}

interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: EmptyStateAction
  className?: string
}

// Icône par défaut (document vide)
const DefaultIcon = () => (
  <svg
    className="w-full h-full"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
)

export default function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center py-12 text-center ${className}`}
    >
      {/* Icône */}
      <div className="w-16 h-16 mb-4 text-gray-300">
        {icon ?? <DefaultIcon />}
      </div>

      {/* Titre */}
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        {title}
      </h3>

      {/* Description */}
      {description && (
        <p className="text-gray-500 mb-4 max-w-sm">
          {description}
        </p>
      )}

      {/* Action */}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="btn-primary"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
